// extracted by mini-css-extract-plugin
module.exports = {"modal-wrapper":"ModalShare_modal-wrapper__3vUl","modalClose":"ModalShare_modalClose_3yD6i"};